import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Avatar, AvatarFallback } from '../../../components/ui/avatar';
import { DropdownMenu, DropdownMenuItem, DropdownMenuSeparator } from '../../../components/ui/dropdown-menu';
import { useAuth } from '../../../hooks/useAuth';
import { Profile, LogoutCurve } from 'iconsax-react';

const ProfileSection = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="relative animate-in fade-in-0" ref={anchorRef}>
      <Button
        variant="ghost"
        className="flex items-center gap-2 px-2"
        onClick={handleToggle}
      >
        <Avatar className="h-8 w-8">
          <AvatarFallback className="bg-primary text-primary-foreground text-sm font-medium">
            {user?.name?.charAt(0) || 'A'}
          </AvatarFallback>
        </Avatar>
        <span className="text-sm font-medium capitalize">
          {user?.name || 'Admin'}
        </span>
      </Button>

      <DropdownMenu open={open} onClose={handleClose} anchorEl={anchorRef.current}>
        <div className="px-3 py-2">
          <p className="text-sm font-semibold">{user?.name || 'Admin User'}</p>
          <p className="text-xs text-muted-foreground">{user?.role || 'Administrator'}</p>
        </div>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={() => { handleClose(); navigate('/profile'); }}>
          <Profile size={16} className="mr-2 text-muted-foreground" />
          <span>My Profile</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={handleLogout}>
          <LogoutCurve size={16} className="mr-2 text-muted-foreground" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenu>
    </div>
  );
};

export default ProfileSection;
